import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/core-js/modules/es6.array.iterator.js";
import "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/core-js/modules/es6.promise.js";
import "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/core-js/modules/es6.object.assign.js";
import "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import "./plugins/element.js";
import '@/assets/scss/yt-project.scss'; // global css

import '@/assets/icons/svg'; // icon

import Message from '@/utils/message';
import * as _tools from '@/utils/tools';
import * as filters from '@/utils/filter';
Vue.prototype.msg = Message;
Vue.prototype.tools = _tools;
Object.keys(filters).forEach(function (k) {
  return Vue.filter(k, filters[k]);
}); // 注册过滤器

Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});